"use client";

import { useState } from "react";
import { SUBMIT_LEAD_API_URL } from "@/lib/rem-api";

/** Web-version launch notification email capture. */
export function PillarWebLaunchForm() {
  const [emailCaptureSubmitted, setEmailCaptureSubmitted] = useState(false);
  const [launchEmail, setLaunchEmail] = useState("");
  const [emailCaptureLoading, setEmailCaptureLoading] = useState(false);
  const [emailCaptureError, setEmailCaptureError] = useState<string | null>(null);

  const handleEmailCapture = async (e: React.FormEvent) => {
    e.preventDefault();
    const email = launchEmail.trim();
    if (!email) {
      setEmailCaptureError("Email is required.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailCaptureError("Please enter a valid email address.");
      return;
    }

    setEmailCaptureLoading(true);
    setEmailCaptureError(null);

    try {
      // Only send email from visible field + requested hidden values.
      const payload = {
        source: "website",
        email,
        notes: "Please notify me when web version of realtorsin get launched",
        lead_tags: [{tag: "Request for Web Version", color: "#2AA2E2"}]
      };

      const res = await fetch(SUBMIT_LEAD_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `Server responded with ${res.status}`);
      }

      setEmailCaptureSubmitted(true);
      setLaunchEmail("");
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : "Something went wrong. Please try again.";
      setEmailCaptureError(message);
    } finally {
      setEmailCaptureLoading(false);
    }
  };

  return (
    <>
      {!emailCaptureSubmitted ? (
        <form className="email-capture-form" onSubmit={handleEmailCapture}>
          <input
            type="email"
            name="email"
            value={launchEmail}
            onChange={(e) => {
              setLaunchEmail(e.target.value);
              if (emailCaptureError) setEmailCaptureError(null);
            }}
            placeholder="Your professional email address"
            required
          />
          <input type="hidden" name="source" value="website" />
          <input
            type="hidden"
            name="notes"
            value="Please notify me when web version of realtorsin get launched"
          />
          <button type="submit" disabled={emailCaptureLoading}>
            {emailCaptureLoading ? "Sending..." : "🔔 Notify Me"}
          </button>
        </form>
      ) : (
        <div style={{ marginTop: "16px", color: "var(--accent)", fontWeight: 700, fontSize: ".95rem" }}>
          ✅ You&apos;re on the list! We&apos;ll notify you at launch.
        </div>
      )}
      {emailCaptureError && (
        <div style={{ marginTop: "10px", color: "#fecaca", fontSize: ".85rem" }}>{emailCaptureError}</div>
      )}
    </>
  );
}
